<template>
  <div id="app">
    <router-view/>
    <VabSnow v-if="!this.overTime"/>
  </div>
</template>

<script>


import VabSnow from './components/VabSnow.vue'

export default {
  name: 'App',
  components: {
    VabSnow
  },
  data () {
    return {
      overTime: new Date().getTime() >= 1735700400000
    }
  }
}
</script>

<style lang="less">
html, body, #app {
  height: 100%;
  min-width: 1905px;
  background: #FFFFFF;
  color: #111111;

  .ant-menu {
    color: #111111;
    font-size: 18px;
    font-weight: 500;
  }

  .ant-menu-horizontal {
    border-bottom: 1px solid #FFFFFF;
  }

  .ant-menu-horizontal > .ant-menu-item:hover, .ant-menu-horizontal > .ant-menu-submenu:hover, .ant-menu-horizontal > .ant-menu-item-active, .ant-menu-horizontal > .ant-menu-submenu-active, .ant-menu-horizontal > .ant-menu-item-open, .ant-menu-horizontal > .ant-menu-submenu-open, .ant-menu-horizontal > .ant-menu-item-selected, .ant-menu-horizontal > .ant-menu-submenu-selected {
    border-bottom: 2px solid #FFFFFF;
  }

  .ant-menu-item, .ant-menu-submenu-title {
  }

  .ant-select-dropdown-menu-item {
    font-family: HarmonyOS Sans SC;
  }
}

#app {
  font-family: HarmonyOS Sans SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/*html::-webkit-scrollbar {
  width: 5px;

}

html::-webkit-scrollbar-thumb {
  background-color: #343183;
  cursor: pointer;
}

html::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  cursor: pointer;
}*/

</style>



// WEBPACK FOOTER //
// src/App.vue